import React from 'react';
import StaticPage, { Section } from './StaticPage';

export default function SafetyPage() {
  return (
    <StaticPage title="Safety & Security" subtitle="Your safety is our top priority. Here's how we keep RentalX safe.">
      <Section title="How We Keep You Safe">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { icon: '✅', title: 'Verified Landlords', desc: 'All landlords with a Verified badge have had their identity and property ownership confirmed by our team.' },
            { icon: '🔒', title: 'Secure Payments', desc: 'Never pay rent or bonds outside the platform process. We provide guidance on safe payment methods.' },
            { icon: '🛡️', title: 'Scam Detection', desc: 'Our system automatically flags suspicious listings. If a deal seems too good to be true, it probably is.' },
            { icon: '📋', title: 'Written Agreements', desc: 'Always use a signed lease agreement. Download our free templates from the Landlord Resources section.' },
          ].map((item, i) => (
            <div key={i} className="p-5 bg-sky-50 rounded-xl border border-sky-100 flex gap-4">
              <span className="text-2xl">{item.icon}</span>
              <div>
                <p className="font-semibold text-gray-800 mb-1">{item.title}</p>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Red Flags to Watch For">
        <ul className="list-disc list-inside space-y-2">
          <li>Landlord asks you to pay a deposit before signing any lease</li>
          <li>Price is significantly below market rate for the area</li>
          <li>Landlord refuses to do a video call or in-person inspection</li>
          <li>Communication is only via WhatsApp or text, no email trail</li>
          <li>Landlord says they're overseas and can only post keys after payment</li>
          <li>Poor-quality photos that look copied from other websites</li>
        </ul>
      </Section>

      <Section title="Report a Concern">
        <p>If you encounter a suspicious listing or landlord, report it immediately:</p>
        <ul className="list-disc list-inside space-y-2 mt-2">
          <li>Use the "Report this listing" button on any property page</li>
          <li>Email us at <strong>safety@rentalx.com.au</strong></li>
          <li>Call <strong>+61 1800 RENTAL</strong> during business hours</li>
        </ul>
        <p className="mt-3 text-sm text-gray-500">For urgent scam matters, also contact <strong>Scamwatch</strong> at scamwatch.gov.au or the Australian Cyber Security Centre.</p>
      </Section>
    </StaticPage>
  );
}
